import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaWhatsapp, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-glow" />

      <div className="footer-container">
        {/* Brand */}
        <div className="footer-brand">
          <Link to="/" className="footer-logo" style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
            <img src="/images/logo.png" alt="Nisarg Plant Library Pvt. Ltd." className="footer-logo-image" style={{ height: '60px', width: 'auto', background: 'white', padding: '5px', borderRadius: '8px' }} />
          </Link>
          <p className="footer-desc">
            Premium plants, expert landscaping, and nature-inspired environments
            crafted for homes & businesses across the region.
          </p>
          <div className="footer-socials">
            <a
              href="https://www.facebook.com/Nisargnurserysangli"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn social-btn--facebook"
              aria-label="Facebook"
            >
              <FaFacebook size={18} />
            </a>
            <a
              href="https://www.instagram.com/nisargnursery7/?fbclid=IwY2xjawSoVklleHRuA2FlbQIxMQBzcnRjBmFwcF9pZAEwAAEe7MRUj7nNCF8BwhWWXYlXtKOUhoLjZ1qbjaZI4grvtMdivl5xt2yZ6V0ZQwM_aem_79FY5nkmkjrca2W4VRxOkA"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn social-btn--instagram"
              aria-label="Instagram"
            >
              <FaInstagram size={18} />
            </a>
            <a
              href="https://wa.me/919175025527"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn social-btn--whatsapp"
              aria-label="WhatsApp"
            >
              <FaWhatsapp size={18} />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            {[['/', 'Home'], ['/about', 'About Us'], ['/services', 'Services'], ['/plants', 'Products'], ['/contact', 'Contact']].map(([path, label]) => (
              <li key={path}>
                <Link to={path} className="footer-link">
                  <span className="link-dot" />
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div className="footer-col">
          <h4 className="footer-heading">Our Services</h4>
          <ul className="footer-links">
            {[['/services/plant-library', 'Plant Library'], ['/services/amc-maintenance', 'AMC Maintenance'], ['/services/training-programs', 'Training Programs'], ['/services/plant-rental', 'Plant Rental Service'], ['/services/franchise-model', 'Franchise Model'], ['/services/plant-store', 'Plant Food & Pots']].map(([path, label]) => (
              <li key={path}>
                <Link to={path} className="footer-link">
                  <span className="link-dot" />
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4 className="footer-heading">Contact Us</h4>
          <ul className="footer-contact-list">
            {[
              { icon: <FaMapMarkerAlt />, text: 'Arwade altia, College corner, Nisarg Nursery, near FAB India, Sangli, Maharashtra 416416' },
              { icon: <FaPhoneAlt />, text: '9175025527' },
              { icon: <FaEnvelope />, text: 'nisargplantlibrary@gmail.com' },
              { icon: <FaClock />, text: 'Mon–Sat: 8AM – 7PM' },
            ].map(({ icon, text }, i) => (
              <li key={i} className="footer-contact-item">
                <span className="contact-icon">{icon}</span>
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>© {currentYear} Nisarg Nursery. All rights reserved.</p>
          <p className="footer-credit">Crafted with 🌿 for nature lovers</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
